import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  CODE_SNIPPET: `${cleanedFilename(__filename)}-code-snippet`,
  GOOGLE_ANALYTICS: `${cleanedFilename(__filename)}-ga-4`,
};
